import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-unknow-user',
  templateUrl: './unknow-user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unknow-user.component.scss']
})
export class UnknowUserComponent {

  constructor() { }

}
